export const ACCESS_TOKEN_KEY = import.meta.env.VITE_ACCESS_TOKEN_KEY;
export const REFRESH_TOKEN_KEY = import.meta.env.VITE_REFRESH_TOKEN_KEY;
export const IMPERSONATE_ACCESS_TOKEN_KEY = import.meta.env.VITE_IMPERSONATE_ACCESS_TOKEN_KEY;
export const IMPERSONATE_REFRESH_TOKEN_KEY = import.meta.env.VITE_IMPERSONATE_REFRESH_TOKEN_KEY;
export const STORAGE_ACCESS_TOKEN_KEY = import.meta.env.VITE_STORAGE_ACCESS_TOKEN_KEY;
export const STORAGE_REFRESH_TOKEN_KEY = import.meta.env.VITE_STORAGE_REFRESH_TOKEN_KEY;
export const STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY = import.meta.env.VITE_STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY;
export const STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY = import.meta.env.VITE_STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY;
export const PUBLIC_PAGE_TOKEN = 'p_p_t';
